<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb
          parentRouteName="PointList"
          :extra-items="[
            '批次異動匯入'
          ]" 
        />
      </div>
    </div>
    <b-card>
      <div class="col-12 col-xl-6 d-flex align-items-center">
        <h4 class="mb-2 mb-xl-0 mr-2 font-weight-bold">批次異動匯入</h4>
      </div>

      <div class="d-flex align-items-center justify-content-between my-2">
        <b-form-select
          v-model="selectedMerchantID"
          :options="merchants"
          class="w-auto"
        ></b-form-select>
        <b-button
          v-b-modal.modal-upload
          class="flex-shrink-0 mb-2 mb-xl-0 mr-2"
          variant="inverse-info"
        >
          <span class="mdi mdi-cloud-upload"></span> 匯入
        </b-button>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="accordion" role="tablist">
            <b-card
              no-body
              class="mb-1"
              v-for="(key, index) in Object.keys(results)"
              :key="index"
            >
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button
                  v-if="key === 'failed'"
                  block
                  v-b-toggle.accordion-0
                  variant="info"
                  >失敗：{{ results.failed.length }}筆</b-button
                >
                <b-button
                  v-if="key === 'created'"
                  block
                  v-b-toggle.accordion-1
                  variant="info"
                  >新增：{{ results.created.length }}筆</b-button
                >
                <b-button
                  v-if="key === 'existed'"
                  block
                  v-b-toggle.accordion-2
                  variant="info"
                  >不異動：{{ results.existed.length }}筆</b-button
                >
              </b-card-header>
              <b-collapse
                :id="`accordion-${index}`"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-table
                    striped
                    hover
                    responsive
                    :items="results[key]"
                    :fields="key === 'failed' ? failedFields : fields"
                    :busy="isLoading"
                  >
                    <template #table-busy>
                      <div class="text-center my-2">
                        <b-spinner class="align-middle"></b-spinner>
                      </div>
                    </template>
                  </b-table>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center">
        <b-button class="mr-4" variant="outline-danger" :to="{name: 'PointList'}">
          返回
        </b-button>
      </div>
    </b-card>

    <b-modal id="modal-upload" title="批次上傳">
      <b-overlay :show="isLoading">
        <div class="form-group">
          <label class="flex-shrink-0 mr-2 mb-0">請上傳 Excel 檔案</label>
          <b-form-file plain v-model="form.file" placeholder="尚未選擇檔案" browse-text="瀏覽"></b-form-file>
        </div>
      </b-overlay>
      <template #modal-footer="{ cancel }">
        <b-button
          size="sm"
          variant="outline-primary"
          href="/excel/point_list.xlsx"
        >
          <i class="fa fa-file-text"></i>下載範例檔案
        </b-button>
        <b-button
          variant="outline-danger"
          size="sm"
          class="float-right"
          @click="cancel()"
        >
          關閉
        </b-button>
        <b-button
          variant="outline-primary"
          size="sm"
          class="float-right"
          @click="handleSubmitFile"
        >
          上傳
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import pointApi from "@/apis/point";
import merchantApi from "../../../apis/merchant";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { mapState } from "vuex";
import * as consts from "@/consts";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  components: {
    BreadCrumb
  },
  data() {
    const fields = [
      {
        key: "row_number",
        label: "第幾列",
      },
      {
        key: "name",
        label: "顯示名稱",
      },
      {
        key: "outer_code",
        label: "會員外部編號",
      },
      {
        key: "mobile_phone",
        label: "手機",
      },
      {
        key: "serial_number",
        label: "用點序號",
      },
      {
        key: "point",
        label: "異動點數",
      },
      {
        key: "expired_at",
        label: "點數到期日",
      },
      {
        key: "description",
        label: "說明",
      },
    ];

    return {
      isLoading: false,
      selectedMerchantID: null,
      merchants: [{ value: null, text: "請選擇通路" }],
      form: {
        file: null,
      },
      results: {
        failed: [],
        created: [],
        existed: [],
      },
      failedFields: [
        ...fields,
        {
          key: "error_message",
          label: "錯誤訊息",
        },
      ],
      fields,
    };
  },

  computed: {
    ...mapState("general", {
      defaultMerchantType: (state) => state.defaultMerchantType,
    }),
  },

  created() {
    this.getMerchants();
  },

  methods: {
    async getMerchants() {
      const { data } = await merchantApi.list();

      this.merchants = [
        { value: null, text: "請選擇" },
        ...data.data.map((merchant) => {
          return {
            value: merchant.id,
            text: merchant.type_name
              ? `${merchant.name} (${merchant.type_name})`
              : merchant.name,
          };
        }),
      ];

      const defaultMerchant = data.data?.find((merchant) => merchant.type === this.defaultMerchantType) ??
        data.data?.find((merchant) => merchant.type === consts.MERCHANT_TYPES.LINE_TYPE) ;
      this.selectedMerchantID = defaultMerchant.id;
    },

    async handleSubmitFile() {
      try {
        if (!this.selectedMerchantID) {
          this.$swal.fire({
            icon: "error",
            title: "請選擇通路",
          });
          return;
        }

        this.isLoading = true;
        const fd = new FormData();
        fd.append("file", this.form.file);

        const { data } = await pointApi.importPoints(
          this.selectedMerchantID,
          fd
        );

        this.results = {
          failed: data.data.failed,
          created: data.data.created,
          existed: data.data.existed,
        }
      } catch (e) {
        this.$swal.fire({
          title: "上傳失敗",
          type: "error",
        });
        console.log(e);
      } finally {
        this.isLoading = false;
        this.$bvModal.hide("modal-upload");
      }
    },
  },
};
</script>

<style></style>
